var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0a1.83 1.83 0 0 1 1.56.867l6.164 9.878a1.839 1.839 0 0 1-1.56 2.806H1.836a1.839 1.839 0 0 1-1.56-2.806L6.438.867A1.83 1.83 0 0 1 8 0zm.999 5.943c.001-.445.003-.89-.005-1.334-.006-.341-.295-.584-.69-.602a6.78 6.78 0 0 0-.591-.001c-.418.018-.707.269-.709.631a446.27 446.27 0 0 0 0 3.73c0 .338.245.583.634.618.26.024.53.019.789-.01.322-.036.56-.276.565-.557.007-.455.005-.91.004-1.365l-.001-.56h.002L9 5.943zM7.995 12A1.001 1.001 0 0 0 9 11.002c0-.55-.453-1.004-1.002-1.002-.544.002-.996.45-.998.992A1.003 1.003 0 0 0 7.995 12z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningIcon);
export default ForwardRef;